import { useCallback } from "react"
import { download, generateCsv, mkConfig } from "export-to-csv"
import type { DateTime } from "luxon"

import { toCsvText } from "../../../../../lib/stringLib"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { useDateTime } from "../../../../localization/useDateTime"

import type { BookingDisplayRow } from "../components/meetigs/helpers"

type Params = Readonly<{
    rows: ReadonlyArray<BookingDisplayRow>
    date: DateTime | null
}>

export function useExportMeetings({ rows, date }: Params) {
    const dateTimeFactory = useDateTime()
    const { l10n } = useAppLocalization()

    return useCallback(() => {
        const startHeader = l10n.getString("service-center-reports-dashboard-meetings-csv-start-header")
        const endHeader = l10n.getString("service-center-reports-dashboard-meetings-csv-end-header")
        const titleHeader = l10n.getString("service-center-reports-dashboard-meetings-csv-title-header")
        const typeHeader = l10n.getString("service-center-reports-dashboard-meetings-csv-type-header")
        const hostHeader = l10n.getString("service-center-reports-dashboard-meetings-csv-host-header")
        const companyHeader = l10n.getString("service-center-reports-dashboard-meetings-csv-company-header")
        const locationHeader = l10n.getString("service-center-reports-dashboard-meetings-csv-location-header")

        const csvOptions = mkConfig({
            fieldSeparator: ";",
            quoteStrings: true,
            useBom: true,
            columnHeaders: [startHeader, endHeader, titleHeader, typeHeader, hostHeader, companyHeader, locationHeader],
            filename: `Facilitynet-bookings-${dateTimeFactory.formatDate(date ?? dateTimeFactory.now())}`,
        })

        const exportRows = rows.map((row) => ({
            [startHeader]: row.start,
            [endHeader]: row.end,
            [titleHeader]: toCsvText(row.title),
            [typeHeader]: row.type,
            [hostHeader]: toCsvText(row.host),
            [companyHeader]: toCsvText(row.company),
            [locationHeader]: toCsvText(row.room),
        }))

        download(csvOptions)(generateCsv(csvOptions)(exportRows))
    }, [rows, date, dateTimeFactory, l10n])
}
